import {Row, Col} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleInfo} from '@fortawesome/pro-light-svg-icons';
import variables from '../../styles/_variables.module.scss';

export const MinimumPolicyDisplay = ({minPolicy, ...otherProps}) => {
  if (minPolicy) {
    return (
      <div className="my-3 p-3 min-policy-bg">
        <Row>
          <Col sm="auto pe-0">
            <FontAwesomeIcon className="align-middle" size="lg" icon={faCircleInfo} color={variables.privoroBlue}/>
          </Col>
          <Col>
            <p className="mb-0 fw-bold">Minimum Policy Requirements</p>
            <p className="mb-0 fst-italic small">Protected Mode Engaged: <strong className="fst-normal">true</strong></p>
            {minPolicy?.is_cellular_connected && <p className="mb-0 fst-italic small">Cellular Radio Off: <strong className="fst-normal">{minPolicy?.is_cellular_connected.toString()}</strong></p>}
            {minPolicy?.has_battery_warning && <p className="mb-0 fst-italic small">Battery Level Sufficient: <strong className="fst-normal">{minPolicy?.battery_warning_threshold.toString()}%</strong></p>}
          </Col>
        </Row>
      </div>
    )
  }

  return null;
};

export default MinimumPolicyDisplay;
